import {useContext, useEffect} from 'external/react'
import Settings from 'context/settings-context'
import useProfile from 'hooks/profile'

export default function useMenu () {
  const {update, state: {dashboardTab, sidebarOpened, menuOpened: open, drawerClicked: clicked, items}} = useContext(Settings.Context)
  const {project, locked} = useProfile()
  const menu = items ? (items.menu[project] || []) : []
  const toggleMenu = (override) => {
    update({menuOpened: {$apply: o => override ? override : !o}, drawerClicked: {$set: true}})
  }

  const toggleSidebar = (override) => {
    update({sidebarOpened: {$apply: o => override ? override : !o}})
  }
  
  const changeDashboardTab = (tab = 'messages') => {
    update({dashboardTab: {$set: tab}})
  }
  
  useEffect(() => {
    if (locked) {
      changeDashboardTab('messages')
    }
  }, [])

  return {menu, clicked, open, toggleMenu, sidebarOpened, toggleSidebar, dashboardTab, changeDashboardTab}

}
